/**
 * Styled components for WithVerticalSources
 */

import styled from 'styled-components';

/**
 * Main panel container - creates the split layout
 */
export const ChatPanel = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  position: relative;
  min-height:0;
`;

/**
 * Chat wrapper - contains transcript and input (grows to fill available space)
 * Conditionally centers content in initial state (no messages)
 */
export const ChatWrapper = styled.div<{ $isInitialState?: boolean }>`
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  min-width: 0; /* Allows flex shrinking */
  overflow: hidden; /* Prevent overflow from breaking layout */
  
  /* Initial state: center content vertically and horizontally */
  ${({ $isInitialState }) =>
    $isInitialState
      ? `
    justify-content: center;
    align-items: center;
  `
      : `
    justify-content: flex-start;
    align-items: stretch;
  `}
`;

